import { useTranslation } from "react-i18next";
import "../../../../css/wallet/SharedWallet/BankAccounts.css";
import { useEffect, useState } from "react";


function Receipts({ theme }) {
  const { t } = useTranslation();

  const [addBankAccountsStatus, setAddBankAccountsStatus] = useState(false);

  const [requestStatus, setRequestStatus] = useState(false);
  const [data, setData] = useState([]);

  useEffect(() => {

  }, []);

  return (
    <div className="bankAccountsContentDiv">
      <div className={`bankAccountssHeaderDiv ${theme}`}>

        {addBankAccountsStatus && (
          {}
        )}
      </div>

      <div className="bankAccountsDiv">
        {data.map((item, index) => {
          return (
            <div key={index} className="bankAccountDiv">
              <img src="/images/bank_card_512.png"></img>
              
                <div className="bankAccountNameDiv">{item.name}</div>
                <div className="bankAccountNumberDiv">{item.card_number}</div>
                <div className="bankAccountNumber2Div">{item.card_number2}</div>
                
              
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default Receipts;
